<script lang="ts">
  import { page } from '$app/stores';
  import { createQuery } from '@tanstack/svelte-query';
  import { client } from '$lib/api/Client';
  import UserProfileContent from '$lib/components/reusable/UserProfileContent.svelte';
  import { derived } from 'svelte/store';

  const profileQuery = createQuery(
    derived(page, ($page) => ({
      queryKey: ['profile', $page.params.username],
      queryFn: () => client.users.retrieveProfile({ username: $page.params.username }),
    })),
  );
</script>

{#if $profileQuery.isSuccess}
  <UserProfileContent
    profile={$profileQuery.data}
    isOwnProfile={$page.params.username === $page.data.username}
  />
{/if}
